import {createAction, props} from '@ngrx/store';
import {User} from '@app/modules/shared/models';

enum EAuthenticationActions {
  LoginUser = '[Authentication] Login User',
  LoginSuccess = '[Authentication] Login Success',
  LoginError = '[Authentication] Login Error',
  LoginFlowRequired = '[Authentication] Login Flow Required',
  CompleteLoginFlow = '[Authentication] Complete Login Flow',
  LogoutUser = '[Authentication] Logout User',
  LogoutSuccess = '[Authentication] Logout Success',
  LogoutError = '[Authentication] Logout Error',
  TokenLogin = '[Authentication] Token Login',
  OneClickLogin = '[Authentication] One Click Login',
  ResetPasswordToken = '[Authentication] Reset Password Token',
  ResetPasswordTokenSuccess = '[Authentication] Reset Password Token Success',
  FORGOT_PASSWORD = '[Authentication] Forget Password',
  FORGOT_PASSWORD_SUCCESS = '[Authentication] Forget Password Success',
  FORGOT_PASSWORD_ERROR = '[Authentication] Forget Password Error',
  RESET_PASSWORD = '[Authentication] Reset Password',
  RESET_PASSWORD_SUCCESS = '[Authentication] Reset Password Success',
  RESET_PASSWORD_ERROR = '[Authentication] Reset Password Error',
  LoginUserWithId = '[Authentication] Login User With Id',
  LoginUserWithIdSuccess = '[Authentication] Login User With Id Success',
  LoginUserWithIdError = '[Authentication] Login User With Id Error',
  EndImpersonation = '[Authentication] End Impersonation',
  EndImpersonationError = '[Authentication] End Impersonation Error',

  ResetAuthState = '[Authentication] Reset Auth State',
}

export const LoginUser = createAction(EAuthenticationActions.LoginUser, props<{ credentials: any }>());
export const LoginSuccess = createAction(EAuthenticationActions.LoginSuccess, props<{ user: User; impersonating?: boolean }>());
export const LoginError = createAction(EAuthenticationActions.LoginError, props<{ error: string }>());
export const LoginFlowRequired = createAction(
  EAuthenticationActions.LoginFlowRequired,
  props<{ flow: any }>()
);
export const CompleteLoginFlow = createAction(
  EAuthenticationActions.CompleteLoginFlow,
  props<{
    flow: any;
    code?: string;
    recovery?: boolean;
    method?: string;
    rememberDevice?: boolean;
    linkToken?: string;
  }>()
);
export const LogoutUser = createAction(EAuthenticationActions.LogoutUser);
export const LogoutSuccess = createAction(EAuthenticationActions.LogoutSuccess);
export const LogoutError = createAction(EAuthenticationActions.LogoutError, props<{ error: string }>());
// `restore`: a page load picking up the session this browser already had. Failing that is
// not an error to report - a sign-in without "Remember me" loses its cookie with the browser.
export const TokenLogin = createAction(
  EAuthenticationActions.TokenLogin,
  props<{ token: string; restore?: boolean }>()
);
export const OneClickLogin = createAction(
  EAuthenticationActions.OneClickLogin,
  props<{token: string}>()
);
export const ResetPasswordToken = createAction(EAuthenticationActions.ResetPasswordToken, props<{ token: string }>());
export const ResetPasswordTokenSuccess = createAction(
  EAuthenticationActions.ResetPasswordTokenSuccess,
  props<{passwordContext: any}>()
);

export const ForgetPassword = createAction(EAuthenticationActions.FORGOT_PASSWORD, props<{ email: string }>());
export const ForgetPasswordSuccess = createAction(EAuthenticationActions.FORGOT_PASSWORD_SUCCESS, props<{ forgetPassword: any }>());
export const ForgetPasswordError = createAction(EAuthenticationActions.FORGOT_PASSWORD_ERROR, props<{ error: string }>());

export const ResetPassword = createAction(EAuthenticationActions.RESET_PASSWORD, props<{ password: string; token: string }>());
export const ResetPasswordSuccess = createAction(EAuthenticationActions.RESET_PASSWORD_SUCCESS, props<{ resetPassword: any }>());
export const ResetPasswordError = createAction(EAuthenticationActions.RESET_PASSWORD_ERROR, props<{ error: string }>());

export const LoginUserWithId = createAction(EAuthenticationActions.LoginUserWithId, props<{ userId: number }>());
export const LoginUserWithIdSuccess = createAction(EAuthenticationActions.LoginUserWithIdSuccess, props<{ user: User }>());
export const LoginUserWithIdError = createAction(EAuthenticationActions.LoginUserWithIdError, props<{ error: string }>());

export const EndImpersonation = createAction(EAuthenticationActions.EndImpersonation);
export const EndImpersonationError = createAction(EAuthenticationActions.EndImpersonationError, props<{ error: string }>());

export const ResetAuthState = createAction(EAuthenticationActions.ResetAuthState, (params: any = {}) => params);
